{
  "alpha": 0.05,
  "ddof": 0,
  "simulate": false,
  "iterations": 500
}
